export default "__VITE_ASSET__8830103e__"